(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;

    if (
      url &&
      url.toLowerCase() ===
        "https://yp5y41seyqbh9byzxx9i9y7q-fast.searchtap.net/v2".toLowerCase() //v2 link
    ) {
      const body = JSON.parse(data);
      const selectedValues = body?.textFacetFilters;

      if (
        selectedValues.option_auto_size?.length > 0 &&
        selectedValues.option_cup_size_txemz4r414x1hhzpjep9dlcu?.length > 0 &&
        body.collection == "8GIQQHPWAMQY4A75QME85EZT"
      ) {
        const optionAutoSize = selectedValues.option_auto_size.join(", ");
        const optionCupSize =
          selectedValues.option_cup_size_txemz4r414x1hhzpjep9dlcu.join(", ");
        const combinedString = (optionAutoSize + optionCupSize).toLowerCase();

        body.filter =
          body.filter +
          " AND option_bra_size__talp6fwajohd5p7kcltqnufz=" +
          combinedString +
          "";
      }
      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);

(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;
    let location = window.location.href;
    let collectionHandle = location.split("/collections/")[1];

    if (
      url &&
      url.toLowerCase() ===
        "https://yp5y41seyqbh9byzxx9i9y7q-fast.searchtap.net/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);

      let sorting = body.sort;

      const str = body.filter;
      const match = str.match(/collectionHandles\s*=\s*"([^"]+)"/);
      const collectionHandle = match ? match[1] : null;

      //console.log("collection handle is", collectionHandle);

      if (collectionHandle === null || collectionHandle === undefined) {
        body.sort = ["sortOrderFor_boost_search_function"];
        data = JSON.stringify(body);
        send.call(this, data);
        return;
      }

      if (
        sorting.length === 0 &&
        !location.includes("/search") &&
        !location.includes("/all") &&
        !location.includes("new-arrivals")
      ) {
        body.sort.unshift("-in_stock"); // Add "-in_stock" as the first element in the sort array
        body.sort.push(`sortOrderFor_${collectionHandle.replaceAll("-", "_")}`);
        body.sort.reverse();
        //console.log("Sort is ", body.sort);
      } else if (
        sorting.length > 0 &&
        !location.includes("/search") &&
        !location.includes("/all") &&
        !location.includes("new-arrivals")
      ) {
        if (!sorting.includes("-in_stock")) {
          body.sort.unshift("-in_stock"); // Add "-in_stock" if it's not already in the sort array
          body.sort.reverse();
          //console.log("Sort is ", body.sort);
        }
      }

      if (
        body.sort.length > 2 && // Adjusted the condition to include both "in_stock" and "sortOrderFor_new_arrivals"
        !location.includes("/search") &&
        !location.includes("/all") &&
        !location.includes("new-arrivals")
      ) {
        sorting = sorting.filter(
          (x) => x !== `sortOrderFor_${collectionHandle.replaceAll("-", "_")}`
        );

        body.sort = sorting;
        body.sort.reverse();
        //console.log("Sort is ", body.sort);
      }

      data = JSON.stringify(body);
    }

    send.call(this, data);
  };
})(XMLHttpRequest);



function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
  x.style.display = "block";

}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
    z.style.display = "";  // Remove the inline style

  
}

window.sq = window.sq || {};

window.sq.changeView = () => {
  const gridButton = document.querySelector('[data-layout-mode="grid"]');
  const listButton = document.querySelector('[data-layout-mode="list"]');
  const productList = document.querySelector(".collection__products");
  const dataGrid = document.querySelector(".sq-results");

  gridButton.addEventListener("click", () => {
    productList?.classList.remove("list-view");
    dataGrid.style.display = "flex";
    gridButton?.classList.add("active");
    dataGrid?.classList.remove("sq-list-view");
    listButton?.classList.remove("active");
    window.sq.custom = { isList: false };
  });

  listButton.addEventListener("click", () => {
    productList?.classList.add("list-view");
    dataGrid?.classList.add("sq-list-view");
    gridButton?.classList.remove("active");
    listButton?.classList.add("active");
    window.sq.custom = { isList: true };
  });
};

window.addEventListener("load", () => {
  // if (window.matchMedia("(max-width: 767px)").matches) {
  //   document
  //     .getElementById("Search-In-Modal")
  //     .addEventListener("focusin", () => {
  //       document.querySelector(".sq-dropdown-body").style.maxHeight = "100%";
  //     });
  //   document
  //     .getElementById("Search-In-Modal")
  //     .addEventListener("focusout", () => {
  //       document.querySelector(".sq-dropdown-body").style.maxHeight = "0px";
  //     });
  // }
});

window.sq.initSearch = (store) => {
  store.search();
};

window.sq.showFilter = function () {
  if (document.querySelector(".sparq-row-base"))
    document.querySelector(".sparq-row-base").style.visibility = null;
  if (document.querySelector(".sq-filter-main"))
    document.querySelector(".sq-filter-main").style.visibility = null;
  if (document.querySelector(".sparq-mobile-filterby"))
    document.querySelector(".sparq-mobile-filterby").style.visibility = null;
};
setTimeout(() => {
  window.sq.showFilter();
  //console.log(document.querySelector(".sparq-filter-btn"));
  if (document.querySelector(".sparq-mobile-filterby"))
    document
      .querySelector(".sparq-mobile-filterby")
      .addEventListener("click", () => {
        toggleFilter();
      });
  if (document.querySelector("#overlay"))
    document.querySelector("#overlay").addEventListener("click", () => {
      removeClass();
    });
  if (document.querySelector(".sq-filter-bottom"))
    document
      .querySelector(".sq-filter-bottom")
      .addEventListener("click", () => {
        removeClass();
      });
  if (document.querySelector(".sq-cross"))
    document.querySelector(".sq-cross").addEventListener("click", () => {
      removeClass();
    });
}, 1000);



// window.sq.availibilitySearchee = function (store) {
//   const inStockFilter = document.getElementById("sq-filter-in-stock").checked;
//   const outStockFilter = document.getElementById("sq-filter-out-stock").checked;
//   // const preorderFilter = document.getElementById("sq-filter-preorder").checked;
//   const url = window.location.href.replace(window.location.search, "");
//   const parts = url.split("-");
//   const subparts = parts[0].split("/");
//   const result = subparts[subparts.length - 1];
//   console.log(result);

//   if (inStockFilter) {
//   store.filter = store.filter + ` tags=instocksize-${result}`;
//   }
//   // store.filter = store.filter.replace("inventory_quantity > 0", "");
//   // store.filter = store.filter.replace(`inventory_quantity <= 0`, "");
//   // // console.log(inStockFilter,outStockFilter);
//   // // console.log(store.filter);
//   // if (inStockFilter && outStockFilter) {
//   // } else {
//   //   if (inStockFilter) store.filter = `inventory_quantity > 0${store.filter}`;
//   //   if (outStockFilter) store.filter = `inventory_quantity <= 0${store.filter}`;
//   // }

//   store.search({ page: 1, restrictByCollection: true });
// };

window.sq.availibilitySearchee = function (store) {
  const inStockFilter = document.getElementById("sq-filter-in-stock").checked;
  const outStockFilter = document.getElementById("sq-filter-out-stock").checked;
  // const preorderFilter = document.getElementById("sq-filter-preorder").checked;
  const url = window.location.href.replace(window.location.search, "");
  const parts = url.split("-");
  const subparts = parts[0].split("/");
  const result = subparts[subparts.length - 1];

  const instockTag = ` tags=instocksize-${result}`;
  const outstockTag = " inventory_quantity=0";

  // Check if inStockFilter is selected and outStockFilter is not selected
  if (inStockFilter && !outStockFilter) {
    // Add inStock tag if it doesn't exist
    if (!store.filter.includes(instockTag)) {
      store.filter += instockTag;
    }
    // Remove outStock tag if it exists
    store.filter = store.filter.replace(outstockTag, '');
  } else if (!inStockFilter && outStockFilter) {
    // Add outStock tag if it doesn't exist
    if (!store.filter.includes(outstockTag)) {
      store.filter += outstockTag;
    }
    // Remove inStock tag if it exists
    store.filter = store.filter.replace(instockTag, '');
  } else {
    // If neither filter is selected, remove both tags (if they exist)
    store.filter = store.filter.replace(instockTag, '').replace(outstockTag, '');
  }

  store.search({ page: 1, restrictByCollection: true });
};

window.sq.checkCollectionHandle = function () {
  let collectionNames = [
    "wirefree-bras",
    "6d-bras-and-swimwear",
    "6dd-bras-and-swimwear",
    "6e-bras-and-swimwear",
    "6f-bras-and-swimwear",
    "6ff-bras-and-swimwear",
    "6g-bras-and-swimwear",
    "6gg-bras-and-swimwear",
    "6h-bras-and-swimwear",
    "6hh-bras-and-swimwear",
    "6j-bras-and-swimwear",
    "6jj-bras-and-swimwear",
    "6k-bras-and-swimwear",
    "8d-bras-and-swimwear",
    "8dd-bras-and-swimwear",
    "8e-bras-and-swimwear",
    "8f-bras-and-swimwear",
    "8ff-bras-and-swimwear",
    "8g-bras-and-swimwear",
    "8gg-bras-and-swimwear",
    "8h-bras-and-swimwear",
    "8hh-bras-and-swimwear",
    "8j-bras-and-swimwear",
    "8jj-bras-and-swimwear",
    "8k-bras-and-swimwear",
    "10d-bras-and-swimwear",
    "10dd-bras-and-swimwear",
    "10e-bras-and-swimwear",
    "10f-bras-and-swimwear",
    "10ff-bras-and-swimwear",
    "10g-bras-and-swimwear",
    "10gg-bras-and-swimwear",
    "10h-bras-and-swimwear",
    "10hh-bras-and-swimwear",
    "10j-bras-and-swimwear",
    "10jj-bras-and-swimwear",
    "10k-bras-and-swimwear",
    "12d-bras-and-swimwear",
    "12dd-bras-and-swimwear",
    "12e-bras-and-swimwear",
    "12f-bras-and-swimwear",
    "12ff-bras-and-swimwear",
    "12g-bras-and-swimwear",
    "12gg-bras-and-swimwear",
    "12h-bras-and-swimwear",
    "12hh-bras-and-swimwear",
    "12j-bras-and-swimwear",
    "12jj-bras-and-swimwear",
    "12k-bras-and-swimwear",
    "14d-bras-and-swimwear",
    "14dd-bras-and-swimwear",
    "14e-bras-and-swimwear",
    "14f-bras-and-swimwear",
    "14ff-bras-and-swimwear",
    "14g-bras-and-swimwear",
    "14gg-bras-and-swimwear",
    "14h-bras-and-swimwear",
    "14hh-bras-and-swimwear",
    "14j-bras-and-swimwear",
    "14jj-bras-and-swimwear",
    "14k-bras-and-swimwear",
    "16d-bras-and-swimwear",
    "16dd-bras-and-swimwear",
    "16e-bras-and-swimwear",
    "16f-bras-and-swimwear",
    "16ff-bras-and-swimwear",
    "16g-bras-and-swimwear",
    "16gg-bras-and-swimwear",
    "16h-bras-and-swimwear",
    "16hh-bras-and-swimwear",
    "16j-bras-and-swimwear",
    "16jj-bras-and-swimwear",
    "16k-bras-and-swimwear",
    "18d-bras-and-swimwear",
    "18dd-bras-and-swimwear",
    "18e-bras-and-swimwear",
    "18f-bras-and-swimwear",
    "18ff-bras-and-swimwear",
    "18g-bras-and-swimwear",
    "18gg-bras-and-swimwear",
    "18h-bras-and-swimwear",
    "18hh-bras-and-swimwear",
    "18j-bras-and-swimwear",
    "18jj-bras-and-swimwear",
    "18k-bras-and-swimwear",
    "20d-bras-and-swimwear",
    "20dd-bras-and-swimwear",
    "20e-bras-and-swimwear",
    "20f-bras-and-swimwear",
    "20ff-bras-and-swimwear",
    "20g-bras-and-swimwear",
    "20gg-bras-and-swimwear",
    "20h-bras-and-swimwear",
    "20hh-bras-and-swimwear",
    "20j-bras-and-swimwear",
    "20jj-bras-and-swimwear",
    "20k-bras-and-swimwear",
    "22d-bras-and-swimwear",
    "22dd-bras-and-swimwear",
    "22e-bras-and-swimwear",
    "22f-bras-and-swimwear",
    "22ff-bras-and-swimwear",
    "22g-bras-and-swimwear",
    "22gg-bras-and-swimwear",
    "22h-bras-and-swimwear",
    "22hh-bras-and-swimwear",
    "22j-bras-and-swimwear",
    "22jj-bras-and-swimwear",
    "22k-bras-and-swimwear",
  ];
  let collectionName = location.href.split("/");
  collectionName = collectionName[collectionName.length - 1]?.split("?")[0];

  // Check if the collectionName contains any item from the collectionNames array
  for (let i = 0; i < collectionNames.length; i++) {
    if (collectionName.includes(collectionNames[i])) {
            console.log(`Collection matched: ${collectionName}`);

      return true;
    }
  }
  console.log(`Collection not matched: ${collectionName}`);

  return false
};
